import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./ValueProps.scss";

const ValueProps = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.12 });

  return (
    <motion.section
      id="value-props"
      className="value-props"
      ref={ref}
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 24 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="value-props__inner">
        <div className="value-props__intro">
          <p className="value-props__eyebrow">Why OllaCart</p>
          <h2 className="value-props__title">
            Shopping online got lonely.
            <span> Your cart doesn&apos;t have to.</span>
          </h2>
        </div>

        <div className="value-props__split">
          <motion.article
            className="value-props__panel value-props__panel--shop"
            initial={{ opacity: 0, x: -20 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.08 }}
          >
            <p className="value-props__tag">For the buy</p>
            <h3>Shop better</h3>
            <p className="value-props__body">
              One cart across every store. Save what you like, come back later,
              and finish with affiliate or direct purchase. No more hunting
              through a dozen half-forgotten tabs.
            </p>
            <ul>
              <li>Universal cart</li>
              <li>Save from anywhere</li>
              <li>Checkout when ready</li>
            </ul>
          </motion.article>

          <motion.article
            className="value-props__panel value-props__panel--social"
            initial={{ opacity: 0, x: 20 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.16 }}
          >
            <p className="value-props__tag">For the people</p>
            <h3>Stay social</h3>
            <p className="value-props__body">
              Share a cart when you want a second opinion. Follow friends who
              open theirs up. Taste is useful before you buy, not after the
              return label.
            </p>
            <ul>
              <li>Share for feedback</li>
              <li>Follow friends&apos; carts</li>
              <li>Private until you say so</li>
            </ul>
          </motion.article>
        </div>
      </div>
    </motion.section>
  );
};

export default ValueProps;
